module.exports = __webpack_public_path__ + "static/media/wisetack-logo.89154ad9.svg";